import "./ProfileMenuComponent.scss";
import React, {useState, useRef} from "react";
import {Menu, MenuItem, ListItemIcon} from "@mui/material";
import {Logout} from "@mui/icons-material";
import {ImageConfig} from "../../../constants";
import {useDispatch, useSelector} from "react-redux";
import {IRootReducerState} from "../../../store/reducers";
import {CommonService} from "../../services";
import {logout} from "../../../store/actions/account.action";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

interface ProfileMenuComponentProps {
}

const ProfileMenuComponent: React.FC<ProfileMenuComponentProps> = () => {
    const dispatch = useDispatch();
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const profileRef = useRef<HTMLDivElement>(null);
    const signature = useSelector(
        (state: IRootReducerState) => state.account.userSignature
    );

    const handleLogout = () => {
        CommonService.openConfirmationDialog({
            confirmationTitle: "Please Confirm !",
            confirmationSubTitle: "Are you sure you want to logout?",
            disableEscKeyClose: false,
            disableBackdropClose: false,
            imagePath: `${ImageConfig.LogoutImage}`,
            direction: "up",
            yes: {
                text: "Logout",
                color: "primary"
            },
            no: {
                text: "Cancel",
                color: "primary"
            }
        })
            .then(() => {
                dispatch(logout());
            })
            .catch(() => {
                // CommonService._alert.showToast("Rejected", "info");
            })
    }

    const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const handleEditSignature = () => {
        CommonService._communications.SignaturePreviewSubject.next(true);
        handleCloseMenu();
    };

    return (
        <>
            {/* Profile Trigger */}
            <div
                className="header-option profile profile-menu-component"
                ref={profileRef}
                onClick={handleOpenMenu}
                style={{cursor: "pointer"}}
            >
                <span className="profile-dp-icon">
                  <ImageConfig.ProfileIcon/>
                </span>
                <div className="profile-name">
                    {currentUser?.firstName} {currentUser?.lastName}
                </div>
                <KeyboardArrowDownIcon/>
            </div>

            {/* Dropdown Menu */}
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                sx={{
                    mt: 1,
                    "& .MuiPaper-root": {
                        minWidth: profileRef.current ? profileRef.current.offsetWidth : "auto",
                    },
                }}
            >
                {signature?.isSignatureRequired && <MenuItem
                    onClick={handleEditSignature}
                >
                    <ListItemIcon>
                        <ImageConfig.SignatureIcon fontSize="small"/>
                    </ListItemIcon>
                    View Signature
                </MenuItem>}
                <MenuItem
                    onClick={() => {
                        handleLogout();
                        handleCloseMenu();
                    }}
                >
                    <ListItemIcon>
                        <Logout fontSize="small"/>
                    </ListItemIcon>
                    Logout
                </MenuItem>
            </Menu>
        </>
    );
};

export default ProfileMenuComponent;
